
export enum PackageFromCustomerStepState
{
    ReturnInfo = "ReturnInfo",
    TimeToSend = "TimeToSend",
    CustomerDeclaredPackageSent = "CustomerDeclaredPackageSent",
    OnTheWay = "OnTheWay",
    NotDelivered = "NotDelivered",
    PackageContentOk = "PackageContentOk",
    PackageContentNotOk = "PackageContentNotOk",
    Cancelled = "Cancelled",
    Delivered = "Delivered",
}
